import { useEffect } from 'react';
import { Link } from 'react-router';
import { useLayoutSlots } from '@app/layouts/layoutContext';
import { useAppStore } from '@app/store/useAppStore';
import { Switch } from '@components/Switch';
import { TuningDropdown } from '@components/TuningDropdown';
import styles from './SettingsRoute.module.css';

const DONATION_URL = 'https://buymeacoffee.com/fretnaught';
const SUPPORT_EMAIL = 'mailto:info@fretnaught.app';

export function SettingsRoute() {
  const { setCenter, setRight } = useLayoutSlots();
  const isLeftHanded = useAppStore((s) => s.isLeftHanded);
  const setLeftHanded = useAppStore((s) => s.setLeftHanded);
  const useTraditionalNames = useAppStore((s) => s.useTraditionalNames);
  const setUseTraditionalNames = useAppStore((s) => s.setUseTraditionalNames);

  useEffect(() => {
    setCenter(
      <div className={styles.form}>
        <section className={styles.section}>
          <h3>Display</h3>
          <Switch label="Left-handed mode" checked={isLeftHanded} onChange={setLeftHanded} />
          <Switch
            label="Use traditional chord names"
            checked={useTraditionalNames}
            onChange={setUseTraditionalNames}
          />
        </section>
        <section className={styles.section}>
          <h3>Tuning</h3>
          <TuningDropdown />
        </section>
        <section className={styles.section}>
          <h3>Help &amp; Feedback</h3>
          <a href={SUPPORT_EMAIL}>Send feedback</a>
          <a href={DONATION_URL} target="_blank" rel="noopener noreferrer">
            Buy me a coffee
          </a>
        </section>
        <section className={styles.section}>
          <h3>About</h3>
          <Link to="/about">About Fretnaught</Link>
          <Link to="/licenses">Open-source licenses</Link>
        </section>
      </div>,
    );
    setRight(null);
    return () => {
      setCenter(null);
      setRight(null);
    };
  }, [
    isLeftHanded,
    useTraditionalNames,
    setLeftHanded,
    setUseTraditionalNames,
    setCenter,
    setRight,
  ]);

  return null;
}
